import React, { useEffect, useState } from "react";
import CompletedListCard from "./CompletedListCard";
import { Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "components/pagination/Pagination";
import { getCompletedRequestsInfo } from "redux/actions/admin/CompletedRequestActions";
import pendingReq from "../../../../assets/img/icons/customIcons/filter.svg";
import SearchIcon from "../../../../assets/img/icons/customIcons/searchicondark.svg";
import CustomFilter from "components/customFilter";

function CompletedList({
  handleEmployeeSearchOnChange,
  handleSearch,
  searchFormData,
  setSearchFormData,
  data,
  companyId,
  toggle,
  list,
  handleClearDate,
  isDashboard,
  handleSearchOnSelect,
}) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [showToggle, setShowToggle] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tableHeight, setTableHeigth] = useState(300);

  const fetchResultCompletedListRequests = useSelector(
    (state) => state.CompletedRequestReducer.result
  );

  const fetchResultCompletedListRequestsLoader = useSelector(
    (state) => state.CompletedRequestReducer.loader
  );

  useEffect(() => {
    setTitle(data);

    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handlePagination = (tab) => {
    // setSearchFormData({
    //   ...searchFormData,
    //   page: tab,
    // })
    const finalData = {
      ...searchFormData,
      page: tab,
    };

    dispatch(
      getCompletedRequestsInfo("1", "1", "completed", finalData, companyId)
    );
  };
  // eslint-disable-next-line
  useEffect(() => {
    const divElement = document.getElementById("tableDiv");
    if (fetchResultCompletedListRequests?.pages?.length > 1) {
      setTableHeigth(divElement.scrollHeight - 72 + "px");
    } else {
      setTableHeigth(divElement.scrollHeight - 12 + "px");
    }
  });
  return (
    <div className="d-flex">
      <Col id="tableDiv" md={isFilter ? "9" : "12"}>
        <Row className="mb-2">
          <Col md="10">
            <h3 className="tab-title">{`${title} (${
              fetchResultCompletedListRequests?.itemCount
                ? fetchResultCompletedListRequests?.itemCount
                : "0"
            })`}</h3>
          </Col>

          <Col md="2" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="common-outer-filter">
              {list && (
                <div className="btn-group new-cutom-filter ">
                  <button
                    type="button"
                    onClick={() => setShowToggle(!showToggle)}
                    className={"btn dropdown-toggle mr-3"}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img alt="" src={pendingReq} width={"18px"} />
                  </button>
                  <div className="dropdown-menu dropdown-menu-right py-0">
                    {list?.map((item, key) => (
                      <button
                        style={{
                          backgroundColor:
                            item?.tabId === "4" ? "#5e72e4" : "none",
                          color: item?.tabId === "4" ? "white" : "none",
                        }}
                        key={key}
                        className="dropdown-item"
                        onClick={() =>
                          toggle({ target: { value: item?.tabId } })
                        }
                        type="button"
                      >
                        {item?.title}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="common-outer-filter">
              <div className="btn-group new-cutom-filter ">
                <button
                  type="button"
                  onClick={() => setIsFilter(!isFilter)}
                  className={"btn dropdown-toggle mr-3"}
                >
                  <img alt="" src={SearchIcon} width={"18px"} />
                </button>
              </div>
            </div>
          </Col>
        </Row>

        <CompletedListCard loader={fetchResultCompletedListRequestsLoader} />

        <div
          style={{
            display: fetchResultCompletedListRequestsLoader
              ? "none"
              : "contents",
          }}
        >
          <PaginationComponent
            totalCount={fetchResultCompletedListRequests?.itemCount}
            handlePagination={handlePagination}
            activePage={fetchResultCompletedListRequests?.activePage}
          />
        </div>
      </Col>
      {/* {isFilter && ( */}
        <Col
          md="3"
          style={{
            height: tableHeight,
            minHeight: "670px",
          }}
        >
          <CustomFilter
            tableHeight={tableHeight}
            minHeight={"670px"}
            handleSearchOnSelect={handleSearchOnSelect}
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleEmployeeSearchOnChange}
            type="outbound"
            list={list}
            isFilter={isFilter}
            setIsFilter={setIsFilter}
            handleClearDate={handleClearDate}
          />
        </Col>
      {/* )} */}
    </div>
  );
}

export default CompletedList;
